<template>
  <div class="">
    <transition enter-active-class="transition duration-100 ease-out" enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100" leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100" leave-to-class="transform scale-95 opacity-0">
      <MenuItems
        class="absolute end-0  mt-8 z-50 w-[30vw] max-h-screen origin-top-right pt-6 px-3 divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div class="h-[50vh] overflow-y-auto" v-if="unreadNotifications.length > 0">
          <div class="px-1 py-1" v-for="(item, index) of unreadNotifications" :key="item.id">
            <MenuItem v-slot="{ active }">
            <button @click="notificationItemClick" :class="[
              active ? '' : '',
              'group flex flex-col w-full items-center rounded-md px-2 py-2 text-sm',
            ]">
              <!-- Welcome notification -->
              <div v-if="item" class="flex items-start justify-start w-full">
                <div class="_img lg:mb-0 mr-4 rounded-lg bg-[#F5F5F5] w-full max-w-[70px] max-h-[70px] h-[70px] flex">
                  <img :src="item.icon" :alt="item.title" class="w-8 h-8 m-auto" />
                </div>
                <div class="text-left">
                  <p class="lg:mb-2 font-bold text-sm text-[#121212]">
                    {{ item.title }}
                  </p>
                  <p class="text-sm text-[#121212]">{{ item.description }} </p>
                </div>
              </div>


            </button>
            </MenuItem>
          </div>
        </div>

        <!-- in case no notifications founded -->
        <div class="h-[50vh] overflow-y-auto flex flex-col items-center justify-center"
          v-if="unreadNotifications?.length == 0">
          <p class="font-medium text-lg text-secondary text-center">{{ t('pages.notifications.havnt_notification') }}</p>
        </div>
        <!-- Notification Footer -->

        <a href="/notifications-center"
          class="block bottom-0 right-0 left-0 font-bold h-1/4 p-3 text-center cursor-pointer">
          <span class="text-sm text-[#1F150F]"> {{ t('pages.notifications.View_All_Notifications') }} </span>
        </a>
      </MenuItems>
    </transition>
  </div>
</template>
<script>
// import Routes from "@/common/Routes"
import { ref, onUnmounted , computed, onBeforeMount } from "vue";
import store from "@/store";
import { useI18n } from "vue-i18n";

import Routes from "@/common/Routes"
import Request from "@/common/Request"
import Response from "@/common/Response"

import { MenuItem, MenuItems } from "@headlessui/vue";

import AnchorButton from "@/components/atoms/buttons/AnchorButton";
import GreyButton from "@/components/atoms/buttons/GreyButton";

export default {
  name: "notification-menu",
  components: {
    AnchorButton,
    GreyButton,
    MenuItem,
    MenuItems,
  },
  setup() {
    const unreadNotifications = computed(() => { return store.getters.unReadNotifications })
    const { t } = useI18n();

    onBeforeMount(() => {

      //get notifications list
      new Request().get('notifications').then((res) => {
        if (res?.data?.data) {
          store.commit('setNotificationsList', res.data.data)
        }
      }).catch((err) => {
      })
    })

    onUnmounted(() => {
      //mark un read notifications
      new Request().get('notifications/read')
    })

    return {
      t,
      unreadNotifications,
      discardOrder(notificationIndex) {
        notifications.value[notificationIndex].isDiscardOrder = true;
        // let newNotificationArr = notifications.value
        // notifications.value= []
        // notifications.value= newNotificationArr
      },
      notificationItemClick(event) {
        event.preventDefault();
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.default-enter-active,
.default-leave-active {
  transition: opacity 0.3s ease;
}

.default-enter-from,
.default-leave-to {
  opacity: 0;
}

.slide-enter-active {
  animation: bounce-in 1s;
}

.slide-leave-active {
  animation: bounce-in 1.4s all;
}

@keyframes bounce-in {
  0% {
    transform: translateX(100%);
    // right: 0
  }

  100% {
    transform: translateX(0%);
    // left:0
  }
}
</style>
